// NATIVE 
import { useSelector } from 'react-redux';


// INSTALLED 
import { Box, Grid, Typography } from '@mui/material'


// CUSTOM 
import { formatDateToYmd, formatDateToYmdNumeric } from '../../../commons/utils'



/**
 * DetalleInformacionLaboral is a React functional component that displays detailed labor information
 * about an employee. It uses Material-UI components such as Grid, Box, and Typography to structure
 * and style the layout.
 *
 * The component retrieves employee data from the Redux store using the `useSelector` hook and displays
 * various personal and labor-related details, including:
 * - Personal information (name, identification number, address, phone, civil status)
 * - Family information (spouse, parents, children under 15 years old)
 * - Labor information (position, salary, contract type, medical exam results)
 * - Social security affiliations (ARL, EPS, pension, family compensation fund)
 * - Required documentation for employment (contract, CV, interview, ID copy, technical test, etc.)
 *
 * Each section is visually separated and styled with borders and background colors to enhance readability.
 *
 * @returns {JSX.Element} The rendered component displaying the employee's detailed labor information.
 */
export const DetalleInformacionLaboral = () => {


  // USE SELECTOR 
  const { employee }:any  = useSelector( (state:any) => state.employee );


  return (

    <>
      
      
      <Grid container spacing={1} sx={{ marginTop: 3 }}>

        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center'}}>
           <img src=" https://pance122.qihotels.net/img_compania/img/qihotels_pance122/image_6005dfe86b00d.png " style={{width: '59%'}} alt="" />
        </Grid>

        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center'}}>
            &nbsp;
               <div className="col-12"><b>HOJA DE RUTA DE PERSONAL</b></div>
             &nbsp;
        </Grid>

        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Grid  style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>CODIGO</Grid>

            <Grid  style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>VERSION</Grid>

            <Grid  style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>FECHA <small>d/m/y</small> </Grid>
        </Grid>

        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Grid xs={12} style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>FM - GH - 07</Grid>

            <Grid xs={12} style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>2</Grid>

            <Grid xs={12} style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>{ formatDateToYmdNumeric( new Date()) }</Grid>
        </Grid>


        
        {/* ********** */}
        <Grid item xs={12} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >DATOS PERSONALES</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        {/* *********** */}
        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NOMBRE Y APELLIDOS</Typography>
          </Box>
        </Grid>
        <Grid item xs={8} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { employee.name+' '+employee.last_name }</Typography>
          </Box>
        </Grid>
        {/* ********** */}


        {/* *********** */}
        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NÚMERO DE IDENTIFICACIÓN</Typography>
          </Box>
        </Grid>
        <Grid item xs={8} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { employee.document_number }</Typography>
          </Box>
        </Grid>
        {/* ********** */}


        {/* *********** */}
        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >DIRECCIÓN</Typography>
          </Box>
        </Grid>
        <Grid item xs={8} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{ employee.address}</Typography>
          </Box>
        </Grid>
        {/* ********** */}




        {/* *********** */}
        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >TELÉFONO</Typography>
          </Box>
        </Grid>
        <Grid item xs={8} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{ employee.cell_phone}</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        {/* *********** */}
        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ESTADO CIVIL</Typography>
          </Box>
        </Grid>
        <Grid item xs={8} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{ employee.civil_status }</Typography>
          </Box>
        </Grid>
        {/* ********** */}




        
        {/* ********** */}
        <Grid item xs={12} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >INFORMACIÓN FAMILIAR</Typography>
          </Box>
        </Grid>
        {/* ********** */}


        {/* *********** */}
        <Grid item xs={6} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NOMBRE</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >OCUPACION</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >EDAD</Typography>
          </Box>
        </Grid>
        {/* ********** */}


        {/* *********** */}
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >CÓNYUGE</Typography>
          </Box>
        </Grid>
        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        {/* ********** */}


        {/* *********** */}
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >PADRE</Typography>
          </Box>
        </Grid>
        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        {/* *********** */}
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >MADRE</Typography>
          </Box>
        </Grid>
        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        {/* ********** */}


        


        
        {/* ********** */}
        <Grid item xs={12} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >RELACIONE HIJOS MENORES DE 15 AÑOS</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        {/* *********** */}
        <Grid item xs={6} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NOMBRE</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ESCOLARIDAD</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >EDAD</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        {/* *********** */}
        <Grid item xs={6} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NOMBRE1</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ESCOLARIDAD1</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >EDAD1</Typography>
          </Box>
        </Grid>
        {/* ********** */}




        {/* *********** */}
        <Grid item xs={6} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NOMBRE2</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ESCOLARIDAD2</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >EDAD2</Typography>
          </Box>
        </Grid>
        {/* ********** */}

        


        {/* *********** */}
        <Grid item xs={6} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NOMBRE3</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ESCOLARIDAD3</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >EDAD3</Typography>
          </Box>
        </Grid>
        {/* ********** */}
      



     
           {/* *********** */}
          <Grid item xs={8} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem' }} >DATOS LABORALES</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem' }} >EXAMEN INGRESO</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem' }} >EXAMEN EGRESO</Typography>
            </Box>
          </Grid>
          {/* *********** */}

       
         
          {/* *********** */}
          <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >CARGO</Typography>
            </Box>
          </Grid>
          <Grid item xs={5} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >{ employee.position.name }</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          {/* *********** */}


          {/* *********** */}
          <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >SALARIO</Typography>
            </Box>
          </Grid>
          <Grid item xs={5} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >$ { employee.salary_base }</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          {/* *********** */}


          {/* *********** */}
          <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >FECHA INGRESO</Typography>
            </Box>
          </Grid>
          <Grid item xs={5} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} > { formatDateToYmd(employee.date_start_contract) }  </Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >Ver</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          {/* *********** */}
        



          {/* *********** */}
          <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >NÚMERO DE CUENTA</Typography>
            </Box>
          </Grid>
          <Grid item xs={5} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >{ employee.account_number }</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          {/* *********** */}


          {/* *********** */}
          <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >TIPO DE CONTRATO</Typography>
            </Box>
          </Grid>
          <Grid item xs={5} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >{ employee.type_contract }</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          {/* *********** */}
        

          {/* *********** */}
          <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >CONCEPTO EXAMEN MÉDICO</Typography>
            </Box>
          </Grid>
          <Grid item xs={5} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} > { (employee.examen_medico) ? 'APTO' : 'NO APTO' } </Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >&nbsp;</Typography>
            </Box>
          </Grid>
          {/* *********** */}

        
         {/* ********** */}
        <Grid item xs={12} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >AFILIACIONES SEGURIDAD SOCIAL</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >AFILIACIÓN</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >ESTADO</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >INGRE</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >EGRE</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >ENTIDAD</Typography>
          </Box>
        </Grid>





        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ARL</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ACTIVO</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >VER</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >AXA COLPATRIA</Typography>
          </Box>
        </Grid>
 

        {/* *************************** */}
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >FONDO CESANTÍAS</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ACTIVO</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >VER</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{ employee.saving.name }</Typography>
          </Box>
        </Grid>

        
        {/* *********** */}
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >EPS</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ACTIVO</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >VER</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{ employee.eps.name }</Typography>
          </Box>
        </Grid>
        {/* ********** */}

        {/* *********** */}
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >PENSIONES</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ACTIVO</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >VER</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{ employee.retirement.name }</Typography>
          </Box>
        </Grid>
        {/* *********** */}


         {/* *********** */}
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >CAJA DE COMPENSACIÓN</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ACTIVO</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >VER</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { employee.familyCompensationFund.name }</Typography>
          </Box>
        </Grid>
        {/* *********** */}



        {/* ************** */}
        <Grid item xs={12} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >DOCUMENTACIÓN REQUERIDA PARA EL INGRESO</Typography>
          </Box>
        </Grid>
        {/* ************** */}

        {/* *********** */}
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >CONTRATO</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >VERIFICACION DE ANTECEDENTES DISCIPLINARIOS</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        {/* *********** */}


        {/* *********** */}
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >HOJA DE VIDA</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { ( employee.cv_name_saved_name && employee.cv_name_saved_name != "" ) ? "OK" : "N/A" } </Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ENTREVISTA</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { ( employee.entrevista && employee.entrevista != "" ) ? "OK" : "N/A" } </Typography>
          </Box>
        </Grid>
        {/* *********** */}



        {/* *********** */}
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >FOTOCOPIA CÉDULA</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }} 
            >    
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { ( employee.cedula_name_saved_name && employee.cedula_name_saved_name != "" ) ? "OK" : "N/A" } </Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >PRUEBA TÉCNICA (si aplica)</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { ( employee.prueba_psicotecnica ) ? 'OK' : 'N/A' }</Typography>
          </Box>
        </Grid>
        {/* *********** */}

        


        {/* *********** */}
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >CERTIFICADO ESTUDIO</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ENCUESTA SOCIODEMOGRÁFICA</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { ( employee.sociodemografica ) ? 'OK' :'N/A' } </Typography>
          </Box>
        </Grid>
        {/* *********** */}

       


       {/* *********** */}
       <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >CERTIFICADO LABORAL</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { ( employee.certificado_laboral ) ? 'OK' : 'N/A' } </Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ENCUESTA DME</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        {/* *********** */}
        




        {/* *********** */}
       <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >VERIFICACION ADRES</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { ( employee.verificacion_adres ) ? 'OK' : 'N/A' } </Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >COMPROMISO SST</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { ( employee.compromiso_sst ) ?  'OK' : 'N/A' } </Typography>
          </Box>
        </Grid>
        {/* *********** */}




        {/* ************** */}
        <Grid item xs={12} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >DOCUMENTOS CÓNYUGUE DEL ASPIRANTE E HIJOS</Typography>
          </Box>
        </Grid>
        {/* ************** */}




        {/* *********** */}
       <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >FOTOCOPIA CÉDULA CÓNYUGUE</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >N/A</Typography>
          </Box>
        </Grid>
        <Grid item xs={4} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >DECLARACIÓN JURAMENTADA O REG CIVIL DE MATRIMONIO</Typography>
          </Box>
        </Grid>
        <Grid item xs={2} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        {/* *********** */}


        {/* *********** */}
       <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >REGISTRO CIVIL HIJOS</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >N/A</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >TARJETA DE IDENTIDAD (Mayores de 8 años)</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >N/A</Typography>
          </Box>
        </Grid>
        {/* *********** */}



        {/* *********** */}
       <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >¿SERÁN BENEFICIARIOS DE SEGURIDAD SOCIAL?</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >N/A</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >OBSERVACIONES</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>
          </Box>
        </Grid>
        {/* *********** */}



      </Grid>
    
     
    </>
  )
}
